import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import 'classnames';
import { IlOverflowMenuItem } from '../../../IlOverflowMenu/IlOverflowMenuItem/index.js';
import { isEnterKeyPressed, isSpaceKeyPressed } from '../../../../shared/utils/keysUtils.js';
import { cssClassPrefix } from '../../../../shared/constants/generalConstants.js';
import { IlIcon } from '../../../IlIcon/index.js';

var BASE_CSS = "".concat(cssClassPrefix, "-header-action-item");

/**
 * IlHeaderActionItem Component
 * ```javascript
 * <IlHeaderActionItem itemText="" hasDivider={boolean} onClick={() => void} active={boolean} closeMenuOnClick={boolean}/>
 * ```
 */
var IlHeaderActionItem = /*#__PURE__*/function (_React$Component) {
  function IlHeaderActionItem() {
    _classCallCheck(this, IlHeaderActionItem);
    return _callSuper(this, IlHeaderActionItem, arguments);
  }
  _inherits(IlHeaderActionItem, _React$Component);
  return _createClass(IlHeaderActionItem, [{
    key: "onKeyPressHandler",
    value:
    // Accessibility
    function onKeyPressHandler(e, onClick) {
      if (isEnterKeyPressed(e) || isSpaceKeyPressed(e)) {
        onClick(e);
      }
    }
  }, {
    key: "renderMobileItem",
    value: function renderMobileItem() {
      var _this = this;
      var _this$props = this.props,
        itemText = _this$props.itemText,
        _this$props$onClick = _this$props.onClick,
        onClick = _this$props$onClick === void 0 ? function () {} : _this$props$onClick,
        active = _this$props.active;
        _this$props.disabled;
      // since we are using the aria-activedescendant navigation technique
      // after clicking a menu item, redirect focus to the menu
      var onFocus = function onFocus(e) {
        return e.currentTarget.parentNode.parentNode.focus;
      };
      return /*#__PURE__*/React__default.createElement("li", {
        role: "none",
        className: "".concat(BASE_CSS, "__mobile-item-wrapper")
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "".concat(BASE_CSS, "__mobile-item"),
        role: "menuitemcheckbox",
        "aria-checked": active,
        onClick: onClick,
        onKeyPress: function onKeyPress(e) {
          return _this.onKeyPressHandler(e, onClick);
        },
        onFocus: onFocus,
        tabIndex: "-1"
      }, active ? this.renderItemTextWithCheck(itemText) : itemText));
    }
  }, {
    key: "renderItemTextWithCheck",
    value: function renderItemTextWithCheck(itemText) {
      this.props.active;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "".concat(BASE_CSS, "__itemText-has-check")
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "".concat(BASE_CSS, "__itemText")
      }, itemText, " "), /*#__PURE__*/React__default.createElement("span", {
        className: "".concat(BASE_CSS, "__check")
      }, /*#__PURE__*/React__default.createElement(IlIcon, {
        name: "check-regular"
      })));
    }
  }, {
    key: "renderDesktopItem",
    value: function renderDesktopItem() {
      var _this$props2 = this.props,
        itemText = _this$props2.itemText,
        className = _this$props2.className,
        _this$props2$onClick = _this$props2.onClick,
        onClick = _this$props2$onClick === void 0 ? function () {} : _this$props2$onClick;
        _this$props2.closeMenuOnClick;
        var closeMenu = _this$props2.closeMenu,
        hasDivider = _this$props2.hasDivider,
        active = _this$props2.active,
        index = _this$props2.index,
        disabled = _this$props2.disabled,
        primaryFocus = _this$props2.primaryFocus;
      return /*#__PURE__*/React__default.createElement(IlOverflowMenuItem, {
        itemText: active ? this.renderItemTextWithCheck(itemText) : itemText,
        onClick: onClick,
        hasDivider: hasDivider,
        closeMenu: closeMenu || function () {
          return true;
        },
        disabled: disabled,
        key: "".concat(index, "_").concat(itemText),
        index: index,
        "aria-checked": active,
        primaryFocus: primaryFocus,
        className: className,
        handleOverflowMenuItemFocus: function handleOverflowMenuItemFocus(e) {
          return window['console'].log(e);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.isMobile) {
        return this.renderMobileItem();
      }
      return this.renderDesktopItem();
    }
  }]);
}(React__default.Component);
_defineProperty(IlHeaderActionItem, "propTypes", {
  itemText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  hasDivider: PropTypes.bool,
  active: PropTypes.bool,
  closeMenuOnClick: PropTypes.bool,
  closeMenu: PropTypes.func,
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.number,
  className: PropTypes.string
});

export { IlHeaderActionItem as default };
